import React from "react";

export default function SectionLoader(props) {
  return (
    <section
      className={`d-flex justify-content-center align-items-center gap-3 p-4 ${
        props.className ?? ""
      }`}
    >
      <div
        className={`spinner-border`}
        role="status"
        style={{ color: "var(--clr-primary-500)", ...props.style }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <h4 className="m-0">Loading...</h4>
    </section>
  );
}
